<template>
  <div class="test-page">
    <top-component></top-component>
    <div class="Context">
      <div class="Sign">
        <!-- <span class="Sign_name">您已累计签到{{ tableTime.length }}天！</span> -->
        <el-badge :value="qiandaonum" class="item">
          <el-button size="small"
            >您已累计签到{{ qiandaonum }}天！</el-button
          >
        </el-badge>
      </div>

      <div class="con">
        <div
          class="content"
          v-for="(item, index) in zhuangtailist"
          :key="index"
        >

          <div
            :class="
              item.a == '已签到'
                ? 'qiandao on'
                : item.a == '漏签'
                ? 'qiandao onq'
                : 'qiandao'
            "
          >
            {{ item.a }}
          </div>
          <div style="margin-left: 10px">{{ item.signdate }}</div>
        </div>
      </div>
      <div class="role">
        <h2>签到规则</h2>

        <el-alert
          title="签到时间:9.19、9.20、9.21、9.22、9.23"
          type="success"
          :closable="false"
          description="  累积签到三天，有精美礼品相送 累积签到三天之后，每多签到一天，
          礼品会变的更加惊喜哟~ (每个账户，只有一份精美的签到礼品)"
          show-icon
        >
        </el-alert>
      </div>

      <div class="role-title">
        <el-button @click="goMyPrice">查看我的奖品</el-button>
      </div>
      <div class="Winning">获得签到奖励人员</div>
      <div id="box">
<!--        <div-->
<!--          id="con1"-->
<!--          ref="con1"-->
<!--          :class="{ anim: animate == true }"-->
<!--          @mouseenter="mEnter"-->
<!--          @mouseleave="mLeave"-->
<!--        >-->
          <vue-seamless-scroll :data="items" class="seamless-warp">
            <ul class="item">
              <li v-for="(item,index) in items" :key="index">
                恭喜<span class="title" style="color:#edd251">{{item.user_id|testfile}}</span>累计签到3天,获得"签到礼品"
              </li>
            </ul>
          </vue-seamless-scroll>

<!--          <div class="box_zj" v-for="(item, index) in items" :key="index">-->
<!--            <el-alert title=" " type="info" :closable="false" class="xin"-->
<!--              >恭喜{{ item.name }}累计签到3天,获得"签到礼品"-->
<!--            </el-alert>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>

    <bottom-component></bottom-component>
  </div>
</template>

<script>
import BottomComponent from "../Components/BottomComponent.vue";
import TopComponent from "../Components/TopComponent.vue";
import { getUserInfo, getUserId } from "@/common/utils/user_info";
import Axios from "@/api/diyaxios";
import Vue from "vue";
import { vueBaberrage, MESSAGE_TYPE } from "vue-baberrage";
Vue.use(vueBaberrage);
import Cookies from "js-cookie";
let timmer=true;
export default {
  name: "calendar",
  data() {
    return {
      msg: "恭喜您中奖了",
      barrageIsShow: true,
      messageHeight: 3,
      boxHeight: 150,
      barrageLoop: true,
      maxWordCount: 3,
      throttleGap: 5000,
      barrageList: [],
      currentDay: 1, // 当前天
      currentMonth: 1, // 当前月
      currentYear: 1970,
      currentWeek: 1, // 一号所在的星期
      days: [], // 当月所有天数
      arrDate: [], // 当月签到日期
      num: 0,
      MonthDay: 0,
      sign: false,
      sign_id: "",
      aaa: true,
      list: [],
      timer: null,
      scrollTime: 20,
      timeList: ["09-19", "09-20", "09-21", "09-22", "09-23"],
      qiandaonum: 0,
      red: false,
      org_name: "", //中奖人
      level: "", //累积签到
      present_name: "", //签到礼品
      dialogVisible: false,
      sinin_zj: false,
      zhuangtailist: [],
      oneqians: "",
      animate: false,
      items: [
        //消息列表对应的数组

      ],
      inters:null
    };
  },
  components: {
    BottomComponent,
    TopComponent,
  },
  destroyed() {
    timmer=false;
  },
  created() {
    // this.getWinningRecord();
    // this.getTime()
    this.sinin();
    this.signature();
    this.getWinningRecord();
    // this.cehsi();
    // this.timer1 = setInterval(this.scroll, 1000); //setInterval定时器，当页面加载完执行定时器

  },
  beforeDestroy() {
    clearInterval(this.timer1);
    clearInterval(this.inters);
    this.timer1 = null;
},
  mounted() {
    let vm = this;
    vm.activityType();
    // vm.record();
  },
  filters:{
    testfile(value){
      if(value.length<=6) return value;
      const start = value.slice(0,6);
      const end = value.slice(-4);
      return start+"******"+end;
    }
  },
  methods: {
    // test(index) {
    //   if (this.tableTime.indexOf(index) == -1) {
    //     return "1";
    //   } else {
    //     return "0";
    //   }
    // },
    // 判断活动类型
    activityType() {
      let vm = this;
      const userinfo = getUserInfo();
      var obj = {
        userid: getUserId(),
      };
      Axios.post(
        "/gold/activate/getnowsign",
        {
          params: obj,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          this.sign_id = res.data.sign_id;
        })
        .catch((err) => {});
    },
    //查询中奖纪录
    goMyPrice() {
      let vm = this;
      vm.$router.push({ name: "myPrice" });
    },
    // 定时获取
    // cehsi() {
    //
    //   this.inters = setInterval(() => {
    //     this.getWinningRecord();
    //   }, 5000);
    // },
    //查询中奖纪录
    getWinningRecord() {
      let vm = this;
      if (Cookies.get("token")) {
        Axios.post(
          "/gold/activate/getrecordlist",
          {
            params: {
              selecttj: "gold_activate_record.activate_id=-1",
              ordertj: "",
              pageSize:100,
                        pageNum:1,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: Cookies.get("token"),
            },
          }
        )
          .then((res) => {
            // this.list = [];
            vm.items = res.data;
            let dely = (vm.items.length/4)*2000;
            if (dely>0&&timmer){
              setTimeout(()=>{
                vm.getWinningRecord();
              },dely)
            }

          })
          .catch((err) => {});
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    // 签到
    sinin() {
      this.dialogVisible = true;
    },
    // 签到确定
    sininOk() {
      this.dialogVisible = false;
    },
    // 点击查看中奖人员
    sininclick() {
      this.sinin_zj = true;
    },
    // 判断签到未签漏签
    signature() {
      var obj = {
        userid: getUserId(),
      };
      Axios.post(
        "/gold/activate/getusersignlist",
        {
          params: obj,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          //   console.log(res);
          let yj = 0 ;
          for (var i in res.data) {
            // console.log(res.data[i].state);
            if (res.data[i].state == 0) {
              res.data[i].a = "已签到";
              this.oneqians = "已签到";
              yj++;
            } else if (res.data[i].state == 2) {
              res.data[i].a = "未签";
            } else {
              res.data[i].a = "漏签";
            }
            //   console.log(this.oneqians);
          }
          this.qiandaonum=yj;
          //   console.log(res.data[i].a);
          this.zhuangtailist = res.data;

          //   console.log(this.zhuangtailist);
        })
        .catch((err) => {});
    },

    //
    // scroll() {
    //   //建一个方法
    //   let con1 = this.$refs.con1;
    //   con1.style.marginTop = "-62px"; //设置style样式 向上移动30px
    //   this.animate = !this.animate; //
    //   var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
    //   setTimeout(function () {
    //     that.items.push(that.items[0]); //尾部追加数组的第一个，放到数组最后
    //     that.items.shift(); //删除第一个元素
    //     con1.style.marginTop = "0px"; //设置style样式 向上移动30px 再回到原位
    //     that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
    //   }, 500);
    // },
    mEnter() {

     // clearInterval(this.timer1); //鼠标移入清除定时器
    },
    mLeave() {
      // this.timer1 = setInterval(this.scroll, 1000); //鼠标离开启动定时器，执行 scroll
    },
  },
};
</script>
<style lang="scss" scoped >
.test-page {
  margin: 0 auto;
  background-color: #e6f3ff;
  .Context {
    width: 553px;
    margin: 20px auto;
    padding: 30px 30px 150px;
    background-color: #fff;
    .Sign {
      width: 100px;
      margin: 0 auto;
    }

    .content {
      width: 500px;
      margin: 0 auto;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      ul {
        width: 100%;
        list-style: none;
        display: flex;
        li {
          float: left;
          text-align: center;
          border-radius: 50%;
          margin: 0 20px;
          span {
            display: inline-block;
            width: 30px;
            height: 30px;
            border: 1px solid rgb(64, 107, 208);
            border-radius: 50%;
          }
        }
      }
    }

    .role {
      width: 500px;
      margin: 0 auto;
      padding: 20px 15px;
      h2 {
        margin-bottom: 10px;
        color: #000;
      }
      h4 {
        margin-bottom: 10px;
      }
      .info {
        margin-bottom: 20px;
      }

      .role-content {
        font-size: 13px;
        color: #333333;
      }
    }
    .role-title {
      width: 500px;
      margin: 0 auto;
      margin-bottom: 40px;
      font-weight: bold;
      font-size: 20px;
      .button {
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}

#listbox1 {
  width: 500px;
  height: 360px;
  color: #fff;
  box-sizing: border-box;
  li {
    height: 40px;
    box-sizing: border-box;
  }
  .winPrice {
    color: #fff;
  }
}
#listbox2 {
  width: 500px;
  height: 400px;
  color: #fff;
  box-sizing: border-box;

  li {
    height: 40px;
    box-sizing: border-box;
  }
}
.on {
  background-color: red;
  color: #fff !important;
  border: none !important;
}
.con {
  display: flex;
  width: 500px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 30px;
}
.itemimag {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #000;
  background-color: #fff;
}
.itemimagcol {
  background-color: #f00;
}
.Winning {
  width: 269px;
  height: 50px;
  color: #000;
  line-height: 50px;
  border-radius: 15px;
  margin-left: 30px;
  font-size: 26px;
  font-weight: 800;
}

.prInfo {
  margin-left: 30px;
  margin-top: 10px;
}

.prInfo-info {
  width: 150px;
  height: 30px;
  background-color: #63000f;
  border-radius: 30px;
  margin: 0 auto;
  margin-bottom: 5px;

  line-height: 30px;
  text-align: center;
}

.notice {
  width: 270px;
  height: 300px;
  border-radius: 8px;
}

.notice__inner {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 14px;
  color: #999;
}

.notice__box {
  animation: roll 5s linear infinite;
  .box_zj {
    margin-top: 20px;
  }
}

.notice__item {
  width: 100%;
  height: 100px;
  line-height: 100px;
  padding: 0 12px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}
.qiandao {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 13px;
  margin-left: 20px;
  background-color: #b4b4b4 ;
}
.on {
  background-color: #459f75;
}
.onq {
  background-color: rgb(148, 62, 62);
}

@keyframes roll {
  0% {
    transform: translatey(0);
  }

  100% {
    transform: translatey(-300px);
  }
}
::v-deep .el-alert__title {
  font-size: 20px !important;
}
::v-deep .el-alert__description {
  font-size: 14px !important;
}

#box {
  width: 500px;
  height: 200px;
  line-height: 30px;
  overflow: hidden;
  padding-left: 30px;
  border: 1px solid #ffffff;
  transition: all 0.1s;
}
.anim {
  transition: all 0.1s;
}
#con1 li {
  list-style: none;
  line-height: 30px;
  height: 30px;
}
.xin{
    margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/ChildPages/calendar.vue